"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.b64 = exports.utf8 = void 0;
var base64_1 = require("@stablelib/base64");
var utf8Encoder = new TextEncoder();
var utf8Decoder = new TextDecoder();
exports.utf8 = {
    decode: function Utf8Decode(input) {
        return utf8Decoder.decode(input);
    },
    encode: function Utf8Encode(input) {
        var buf = utf8Encoder.encode(input);
        return new Uint8Array(buf, 0, buf.length);
    },
};
exports.b64 = {
    urlSafe: function (str) { return str.replace(/\+/g, '-').replace(/\//g, '_'); },
    encode: function b64Encode(input) {
        return (0, base64_1.encodeURLSafe)(input);
    },
    decode: function b64Decode(input) {
        return (0, base64_1.decodeURLSafe)(exports.b64.urlSafe(input));
    },
};
